import { format, formatDistanceToNow, parseISO } from "date-fns";

export function formatCurrency(amount: string | number, currency = "BDT") {
  const n = typeof amount === "string" ? Number(amount) : amount;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number.isFinite(n) ? n : 0);
}

export function formatNumber(n: string | number) {
  const v = typeof n === "string" ? Number(n) : n;
  return new Intl.NumberFormat("en-US").format(Number.isFinite(v) ? v : 0);
}

export function formatDate(iso: string | null | undefined) {
  if (!iso) return "—";
  try { return format(parseISO(iso), "MMM d, yyyy"); }
  catch { return "—"; }
}

export function formatDateTime(iso: string | null | undefined) {
  if (!iso) return "—";
  try { return format(parseISO(iso), "MMM d, yyyy • HH:mm"); }
  catch { return "—"; }
}

export function formatRelative(iso: string | null | undefined) {
  if (!iso) return "—";
  try { return formatDistanceToNow(parseISO(iso), { addSuffix: true }); }
  catch { return "—"; }
}

export function truncateMiddle(s: string, keep = 6) {
  if (!s || s.length <= keep * 2 + 3) return s;
  return `${s.slice(0, keep)}…${s.slice(-keep)}`;
}
